import { axiosInstance } from "./axiosInstance";

export const setupScheduleService = {
    deleteSetupSchedule: async (id) => { // id is setup schedule id
        return await axiosInstance.delete(`/api/superadmin/setup-schedule/delete/${id}`)
    }, 
    createSetupSchedule: async (id, data) => { // id is branch id
        return await axiosInstance.post(`/api/superadmin/setup-schedule/create/${id}`, data)
    },
    updateSetupSchedule: async (data) => { // id is setup schedule id
        return await axiosInstance.post(`/api/superadmin/setup-schedule/updateDaily`, data)
    },
}